import { ButtonInterface } from 'common/types/entities/button-interface'
import React from 'react'
import { CommonButtonSettings } from '../common-button-settings'

interface LoginButtonSettingsProps {
  entity: ButtonInterface
}

export const LoginButtonSettings = ({ entity }: LoginButtonSettingsProps) => {
  return <CommonButtonSettings entity={entity} />
}
